module.exports = __webpack_public_path__ + "img/prizeTitle.d53994ca.png";